import { twMerge } from 'tailwind-merge';

import LogoDark from '../../assets/sm-full-logo-dark.png';
import LogoLight from '../../assets/sm-full-logo-light.png';

interface Props {
  className?: string;
  type?: 'dark' | 'light';
}

export function LogoFull(props: Props) {
  const type = props.type || 'light';

  return (
    <img
      className={twMerge(props.className)}
      src={type === 'dark' ? LogoDark : LogoLight}
      alt="Solana Mobile"
    />
  );
}
